import { HeartFilledIcon } from '@iheartjane/reefer';

export const FavoriteSavedToastLabel = () => (
  <>
    <HeartFilledIcon color="grays-white" mr={12} />
    Saved to your favorites
  </>
);
